import { TransferRateModel } from '@rd/types/transfer-rate.model';
import { TransferRate, TransferRateType } from '@rd/types/transfer-rate.type';

export function transferRateSerializer({
  id,
  attributes,
  type,
}: TransferRateModel): TransferRate {
  switch (type) {
    case TransferRateType.Cash: {
      return {
        id: id,
        type: TransferRateType.Cash,
        ...attributes,
      };
    }
    case TransferRateType.Points: {
      return {
        id: id,
        type: TransferRateType.Points,
        ...attributes,
      };
    }
  }
}
